import React from 'react';

import Aux from '../../../hoc/ReactAux/ReactAux'
import './Modal.css'
import Logo from 'images/cart-mark.png'
import ReactModal from 'react-modal'

const customStyles = {
  content: {
    background : 'none',
    border: 'none',
  },
  overlay : {
    zIndex                   : '9999999',
    width                    : '100%',
    height                   : '100%',
    left                     : '0',
    top                      : '0',
    backgroundColor         : 'rgba(0, 0, 0, 0.7)'
  }
}

const ModalCartMessage = (props) => {

  if (!props.showModal) {
    return null;
  }

  return (
    <Aux>
      <ReactModal
          isOpen={props.showModal}
          style={customStyles}
          onRequestClose={props.clickButtonDeny}
          shouldCloseOnOverlayClick={true}
          shouldCloseOnEsc={true}
          contentLabel="Example Modal">
            <div id="lb-cart-message"
                 className="lb-geral lb-cart-message_ mfp-bg-login white-popup-block lb-centralizar singup zoom-anim-dialog Modal">
              <div className="lb-padrao-singup6 mfp-content-login modal-content">
                <button onClick={props.clickButtonDeny}
                        type="button"
                        className="bt-close mfp-close lb-fechar fa fa-times"/>
                <div className="check-mark">
                     <img alt="cart mark" src={Logo} />
                </div>
                <div className="lb-content">
                  <span className="order">
                        {props.message}
                  </span>
                  <div className="no-yes wrapper">
                    <a onClick={props.clickButtonDeny} className="bt no">No</a>
                    <a onClick={props.clickButtonConfirm} className="bt yes">Yes</a>
                  </div>
                </div>
              </div>
            </div>
      </ReactModal>
    </Aux>
  )
}

export default ModalCartMessage;



// WEBPACK FOOTER //
// ./src/components/UI/Modal/ModalCartMessage.js